import { render, staticRenderFns } from "./SettingsOverflow.vue?vue&type=template&id=4f458594&"
import script from "./SettingsOverflow.vue?vue&type=script&lang=js&"
export * from "./SettingsOverflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports